import { Component } from '@angular/core';
import { environment } from '@environments/environment';

const ENV_BANNER_ENVIRONMENTS = ['UAT', 'STAGING'] as const;

@Component({
    selector: 'avenir-top-header',
    imports: [],
    templateUrl: './top-header.component.html',
    styleUrl: './top-header.component.scss'
})
export class TopHeaderComponent {
    readonly envBannerText = environment.ENV_NAME;
    readonly shouldShowEnvBanner = (ENV_BANNER_ENVIRONMENTS as readonly string[]).includes(
        environment.ENV_NAME
    );
}
